import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBest = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.94285 2.52756C6.00069 2.52535 6.15815 2.52366 6.20907 2.52476C7.05163 2.54311 7.06489 4.02664 7.80732 4.87959C8.59271 5.78183 9.89984 5.86458 10.3917 6.41492C10.5812 7.5497 8.87513 7.52436 8.07302 8.19583C7.29648 8.84593 7.045 10.5332 6.47211 10.8726C6.42894 10.8734 6.38569 10.8732 6.34251 10.872C6.30243 10.8704 5.99443 10.8386 5.98603 10.8322C5.36186 10.3539 5.15489 9.15496 4.58038 8.47391C3.77039 7.51367 3.03319 7.76324 2.163 7.041C2.03192 6.93224 1.9729 6.63781 2.0118 6.54327C2.24626 5.97378 3.46593 5.84292 4.10277 5.37149C5.05799 4.66436 5.44299 2.95124 5.94285 2.52756Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33484 8.99324C3.54197 8.96907 3.61889 9.02139 3.81179 9.10119C4.22736 9.68284 3.04218 10.5548 2.64075 10.9116C2.30557 10.8677 2.06912 10.7261 2.02734 10.387C2.21236 9.88016 2.90535 9.36519 3.33484 8.99324Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.40416 2.5C2.94802 2.51385 3.78026 3.42789 3.91046 3.9601C3.84297 4.25402 3.81408 4.20775 3.57248 4.45893C3.10511 4.35821 2.11076 3.41484 2.04297 2.90968C2.13507 2.64818 2.14937 2.70034 2.40416 2.5Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.92745 8.90918C9.40852 9.09346 10.3713 9.93484 10.3778 10.5182C10.2974 10.7521 10.1854 10.805 9.9876 10.9457C9.52023 10.7599 8.6297 9.92018 8.56641 9.3834C8.60782 9.14703 8.7456 9.06281 8.92745 8.90918Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.82893 2.51371C10.1432 2.51084 10.3348 2.65997 10.4056 2.94999C10.2782 3.4668 9.54429 4.05295 9.12982 4.4344C8.88535 4.38341 8.84048 4.34377 8.64308 4.20812C8.34474 3.57305 9.3774 2.89524 9.82893 2.51371Z",
			fill: "#C4D7FD"
		})
	]
});
export default SvgBest;
